export const USER_ROLE = {
  ADMIN: 'Admin',
  DOCTOR: 'Doctor',
  WORKER: 'Worker', // 建模组员
  AGENT: 'Agent',
  CAPTAIN: 'Captain' // 建模组长
};

export const TASK_STATUS = {
  UNSUBMIT: 0,
  SUBMITED: 1,
  PROCESSING: 2,
  FINISHED: 3,
};

export const ORDER_STATUS = {
  INIT: 0, // 已提交
  PAID: 1,
  FINISHED: 2,
  FAILED: 3,
};



// WEBPACK FOOTER //
// ./src/config/enum.js